import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Attachment } from './models/attachment-model';

@Injectable({
  providedIn: 'root'
})
export class AttachmentService {
  apiGatewayUrl: string;

  constructor(private http: HttpClient) {
    this.apiGatewayUrl = environment().apiGatewayUrl;
  }

  uploadFile(route: string, id: number, file: File): Observable<HttpResponse<any>> {
    const formData = new FormData();

    formData.append('file', file, file.name);
    formData.append('id', id.toString());

    return this.http.post<any>(`${this.apiGatewayUrl}${route}`, formData, { observe: 'response' });
  }

  downloadAttachment(downloadRoute: string, attachment: Attachment) {
    const params = new HttpParams()
      .append('location', attachment.location)
      .append('fileName', attachment.name);
      
    return this.http.get(`${this.apiGatewayUrl}${downloadRoute}`, { params: params, responseType: 'blob' });
  }
}
